import(/* webpackMode: "eager", webpackExports: ["MainFooter"] */ "/work/apps/frontend/src/features/layouts/MainFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MainHeader"] */ "/work/apps/frontend/src/features/layouts/MainHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FloatingActions"] */ "/work/apps/frontend/src/shared/ui/FloatingActions.tsx");
